var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58665 0.193535L3.99999 2.7802L1.41332 0.193535C1.15332 -0.0664648 0.73332 -0.0664648 0.47332 0.193535C0.21332 0.453535 0.21332 0.873535 0.47332 1.13354L3.53332 4.19353C3.79332 4.45354 4.21332 4.45354 4.47332 4.19353L7.53332 1.13354C7.79332 0.873535 7.79332 0.453535 7.53332 0.193535C7.27332 -0.0597982 6.84665 -0.0664648 6.58665 0.193535Z",
    fill: "#2D2C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/DropDown.f079199a2b5769beb28cef304c9f518a.svg";
export { ForwardRef as ReactComponent };